import React, { FC } from "react";
import "./style.scss";
// import Save3 from "../../../../assets/save3.svg";
import Star from "../../../../assets/Star.svg";
import StarActive from "../../../../assets/StarActive.svg";

type PropsType = {
  onclick: () => void;
  saved: boolean;
};
const SaveToFavBtn: FC<PropsType> = ({ onclick, saved }) => {
  return (
    <button
      onClick={onclick}
      className={"save-to-favorites-star"}
      style={{ opacity: saved ? 1 : 0.8 }}
    >
      <img src={saved ? StarActive : Star} alt="Save" />
    </button>
  );
};

export default SaveToFavBtn;
